import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { Container, Row, Col } from "react-bootstrap";
import styled from "styled-components";

const StyledContainer = styled(Container)`
    background: radial-gradient(circle, rgba(69,185,25,1) 0%, rgba(51,105,30,1) 58%, rgba(42,89,52,1) 100%);
    & h2 {
        color: var(--highlight-cream);
        font-family: "Roboto Slab", serif;
        font-weight: 700;
        font-size: 2.5rem;
    }
    & blockquote {
        color: #222;
        font-family: "Poppins", sans-serif;
        font-weight: 400;
        border-radius: 10px;
        background: var(--highlight-cream);
    }
    & footer {
        color: #2e7736;
        font-family: "Poppins", sans-serif;
        font-weight: 400;
        font-size: 1.1rem;
        margin-top: 1rem;
    }
`;


function Responsive() {
  var testimonials = [
    {
      name: "Alison Watson",
      testimonial: "Glorious carpets of wood anemones in the wood.",
    },
    {
      name: "Penny Sewell",
      testimonial:
        "Our working sessions in Queen's Wood are a highlight of the month for me. I love the work - be it building dry wood fences, chopping down holly, clearing goat willow, or even just litter-picking. It all gives me the greatest pleasure.",
    },
    {
      name: "Linda LeRoy",
      testimonial:
        "I love to walk in Queen's Wood but after a morning of clearing branches and debris left by tree surgeons I feel some proprietorial pride too. It is fun to work with other volunteers, to be outdoors with purpose.",
    },
    {
      name: "Sue Smith",
      testimonial:
        "So many memories - where to begin? Early morning walks with three young children, sometimes on their bicycles. Hide and seek, playing, dodging behind trees. Sparrow hawks calling in early April. Changing seasons but always something new and fresh. So lucky to have this wonderful space...",
    },
  ];
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <StyledContainer>
      <Row>
        <Col xs={12}>
          <h2>What people have said:</h2>
          <Slider {...settings}>
            {testimonials.map((testimonial, index) => (
              <div key={index}>
                <blockquote className="testimonial-testimonial">
                  {testimonial.testimonial}
                  <footer className="testimonial-name">
                    {testimonial.name}
                  </footer>
                </blockquote>
              </div>
            ))}
          </Slider>
        </Col>
      </Row>
    </StyledContainer>
  );
}

export default Responsive;
